module.exports = __webpack_public_path__ + "static/media/navidad7.99bc9dd8.webp";